import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Fragment } from 'react';
import { GridLabel, GridData } from './StyledGrids';
import { FieldLabel } from './FieldLabel';
import { FieldData } from './FieldData';
export const Fields = (_ref) => {
  let {
    classes,
    label,
    data,
    i,
    LabelTypographyProps,
    DataTypographyProps
  } = _ref,
      props = _objectWithoutProperties(_ref, ["classes", "label", "data", "i", "LabelTypographyProps", "DataTypographyProps"]);

  return /*#__PURE__*/React.createElement(Fragment, null, label && /*#__PURE__*/React.createElement(GridLabel, {
    item: true,
    className: "label",
    xs: 6,
    sm: 4
  }, /*#__PURE__*/React.createElement(FieldLabel, _extends({
    classes: classes,
    label: label,
    i: i
  }, props, LabelTypographyProps))), /*#__PURE__*/React.createElement(GridData, {
    item: true,
    className: "data",
    xs: true
  }, /*#__PURE__*/React.createElement(FieldData, _extends({
    data: data
  }, DataTypographyProps, props))));
};